export default __webpack_public_path__ + "static/media/userMessage.a3b55abf.svg";